export { webComponentThemeProps, WebComponentThemeMixin } from './webcomponent_theme_mixin'
export { PrimaryButtonColorDiffMixin } from './primary_button_color_diff_mixin'

/* Mixins file
  Each non-class Mixin should have a name in this format:
    name_mixin
  Class-style mixins must be in PascalCase and should end in "__Mixin"
*/

import { mapGetters, mapActions } from 'vuex'

import Vue from 'vue'

export const authenticate_mixin = Vue.extend({
  computed: {
    ...mapGetters ('user', ['connectionToken'])
  },
  created () {
    if(this.$route.query.token) {
      this.$store.commit('user/setConnectionToken', this.$route.query.token)
      this.$cookies.set('buyside.connectionToken', this.$route.query.token)
    }
    if(this.connectionToken) {
      this.$store.dispatch('user/getUser')
    }
  }
})

export const loginOrClaimModal_mixin = Vue.extend({
  computed: {
    ...mapGetters('user', [
      'isLoggedIn'
    ]),
    loginOrClaim() {
      if(!this.isLoggedIn) {
        return 'modalOneall'
      }
      return 'modalClaim'
    }
  }
})

export const subscribeMonthlyReport_mixin = Vue.extend({
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
    }
  },
  computed: {
    ...mapGetters('user', ['details']),
    userFirstName(): string {
      return this.details.first_name
    },
    userLastName(): string {
      return this.details.last_name
    },
    userEmail(): string {
      return this.details.email
    },
    successMessage(): string {
      return "You have been subscribed to monthly reports for this address.";
    },
    failureMessage(): string {
      return "There was an error in adding your subscription. Please try again.";
    }
  },
  methods: {
    ...mapActions('leads', ['subscribeMonthlyReport']),
    async subscribeToReport() {
      try {
        const result = await this.subscribeMonthlyReport({
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email
        })
        return result;
      }
      catch (e)
      {
        return false;
      }
    }
  },
  watch: {
    userFirstName: {
      immediate: true,
      handler: function() {this.firstName = this.userFirstName}
    },
    userLastName: {
      immediate: true,
      handler: function() {this.lastName = this.userLastName}
    },
    userEmail: {
      immediate: true,
      handler: function() {this.email = this.userEmail}
    }
  }
})

export const generateOrUpdateLead_mixin = Vue.extend({
  computed: {
    ...mapGetters('leads', ['leadID']),
  },
  methods: {
    async generateOrUpdateLead (leadTypesToAdd: string[]) {
      if(!this.leadID) {
        const theLeadID = await this.$store.dispatch('leads/createLead', { payload: {
          address: this.$store.state.listings.address,
          leadTypes: leadTypesToAdd,
        }})
        this.$store.commit('leads/setLeadID', theLeadID)
      }
      else {
        //update LeadID with new leadType ["Valuation Attempt"]
        this.$store.dispatch('leads/updateLead', {
          address: this.$store.state.listings.address,
          leadTypes: leadTypesToAdd,
        });
      }
    }
  }
})
